
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pfps",
      function () {
        return require("private-next-pages/pfps/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pfps"])
      });
    }
  